import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, custom }) => ({
  root: {
    maxWidth: custom.form.maxWidth,
  },
  heading: {
    marginBottom: 20,
  },
  content: {
    marginBottom: 40,
    width: 'auto !important',
  },
  headingTitlePlaceholder: {
    minWidth: 300,
  },
  formRow: {
    marginBottom: 15,
  },
  [breakpoints.down(426)]: {
    headingTitlePlaceholder: {
      minWidth: 150,
    },
  },
}));
